import type {
  BannerBackgroundThemeOptions,
  TBannerOptions,
  TImageOptions,
} from '@tarslib/types/lib/publishedProject';

export enum FooterBannerType {
  Image = 'image',
  QRCode = 'qrCode',
}

export type FooterBannerImage = TImageOptions & {
  type: FooterBannerType.Image;
  key: string;
};

export type FooterBannerQRCode = Omit<TBannerOptions, 'backgroundTheme'> & {
  type: FooterBannerType.QRCode;
  backgroundTheme: BannerBackgroundThemeOptions;
  key: string;
};

export type FooterBanner = FooterBannerImage | FooterBannerQRCode;
